<template>
  <BInputGroup class="vue-timepicker">
    <BInputGroupPrepend>
      <BInputGroupText @click="openTimepicker">
        <Icon :title="tr('common.OPEN_TIMEPICKER')"
              name="clock"></Icon>
      </BInputGroupText>
    </BInputGroupPrepend>
    <VueTimepicker ref="timepicker"
                   :model-value="modelValue"
                   :minute-interval="minuteInterval"
                   :hour-range="hourRange"
                   :minute-range="minuteRange"
                   :placeholder="placeholder"
                   :disabled="disabled"
                   :manual-input="manualInput"
                   input-class="form-control"
                   input-width="100%"
                   :lazy="lazy"
                   :advanced-keyboard="advancedKeyboard"
                   hide-clear-button
                   close-on-complete
                   @update:model-value="onChange"
                   @open="onOpen"
                   @close="onClose"></VueTimepicker>
  </BInputGroup>
</template>

<script>
  import VueTimepicker from '@meteocontrol/vue3-timepicker';
  import { BInputGroup, BInputGroupPrepend, BInputGroupText } from 'bootstrap-vue';
  import { dateFormat, translator } from '~/zf/frontend/common/mixins';
  import Icon from './Icon.vue';

  export default {
    name: 'Timepicker',
    compatConfig: {
      MODE: 3,
      COMPONENT_FUNCTIONAL: true, // needed for BInputGroupPrepend
    },
    components: {
      BInputGroup,
      BInputGroupText,
      BInputGroupPrepend,
      Icon,
      VueTimepicker,
    },
    mixins: [
      dateFormat,
      translator,
    ],
    props: {
      modelValue: {
        type: Object,
        default() {
          return { HH: '', mm: '' };
        },
      },
      minuteInterval: {
        type: Number,
        default() {
          return 5;
        },
      },
      hourRange: Array,
      minuteRange: Array,
      placeholder: String,
      disabled: Boolean,
      lazy: {
        type: Boolean,
        default: false,
      },
      manualInput: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    computed: {
      advancedKeyboard() {
        return !this.manualInput;
      },
    },
    methods: {
      onChange(value) {
        this.$emit('update:modelValue', value);
      },
      onClose() {
        this.$refs.timepicker.$el.querySelectorAll('input.vue__time-picker-input')[0].classList.remove('focused');
      },
      onOpen() {
        this.$refs.timepicker.$el.querySelectorAll('input.vue__time-picker-input')[0].classList.add('focused');
      },
      openTimepicker() {
        const targetInputBox = this.$refs.timepicker.$el.querySelectorAll('input.vue__time-picker-input')[0];
        targetInputBox.focus();
      },
    },
  };
</script>
<style src="@meteocontrol/vue3-timepicker/dist/VueTimepicker.css"></style>
<style scoped lang="scss">
    :deep(.vue__time-picker) {
      -webkit-box-flex: 1;
      flex: 1 1 0;

      input.display-time, input.vue__time-picker-input {
        height: calc(1.5em + 1.33334rem + 2px);
        padding: 0.66667rem 1rem;
      }
    }

    :deep(.vue__time-picker .dropdown) {
      top: calc(2.2em + 10px);
    }
</style>
